import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-7839d232")

_pushScopeId("data-v-7839d232")
const _hoisted_1 = { class: "calendar-frame" }
const _hoisted_2 = { class: "calendar-header" }
const _hoisted_3 = { class: "calendar-content" }
const _hoisted_4 = { class: "calendar-week-name" }
const _hoisted_5 = { class: "calender-number" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_arrow_button = _resolveComponent("arrow-button")
  const _component_calendar_day_frame = _resolveComponent("calendar-day-frame")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_arrow_button, {
        class: "calendar-header-button",
        icon: "angle-left",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addMonth(-1)))
      }),
      _createVNode("div", null, _toDisplayString(_ctx.year) + " " + _toDisplayString(_ctx.month + 1) + "月", 1),
      _createVNode(_component_arrow_button, {
        class: "calendar-header-button",
        icon: "angle-right",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addMonth(1)))
      })
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.calendarHeader, (name, index) => {
          return (_openBlock(), _createBlock("div", {
            key: 'week-name'+index,
            class: [
            'calendar-week-name-item',
            name==='日' ? 'calendar-week-name-item-sunday' : '',
            name==='土' ? 'calendar-week-name-item-saturday' : ''
          ]
          }, _toDisplayString(name), 3))
        }), 128))
      ]),
      _createVNode("div", _hoisted_5, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.calendar, (week, weekIndex) => {
          return (_openBlock(), _createBlock("div", {
            class: "calendar-number-row",
            key: 'week'+weekIndex
          }, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(week, (day, dayIndex) => {
              return (_openBlock(), _createBlock(_Fragment, null, [
                day
                  ? (_openBlock(), _createBlock(_component_calendar_day_frame, {
                      key: 'day'+weekIndex+'-'+dayIndex,
                      year: _ctx.year,
                      month: _ctx.month,
                      day: day,
                      disableAfterToday: _ctx.disableAfterToday,
                      disableAdd: _ctx.disableAdd,
                      "holiday-name": _ctx.holidayName(_ctx.year, _ctx.month, day),
                      onAdd: ($event: any) => (_ctx.$emit('add', { day }))
                    }, {
                      default: _withId(() => [
                        _renderSlot(_ctx.$slots, `day_${day}`, {}, undefined, true)
                      ]),
                      _: 2
                    }, 1032, ["year", "month", "day", "disableAfterToday", "disableAdd", "holiday-name", "onAdd"]))
                  : (_openBlock(), _createBlock("div", {
                      key: 'day'+weekIndex+'-'+dayIndex,
                      class: "calendar-day-frame-invalid"
                    }))
              ], 64))
            }), 256))
          ]))
        }), 128))
      ])
    ])
  ]))
})